import React from 'react';
import { useParams } from 'react-router-dom';
// import ReactMarkdown from 'react-markdown';
import parseHTML from 'html-react-parser';

import data from '../data/articles.json';

import Text from '../composant/Text';
import Images from '../composant/Images';
import Header from '../composant/Header';
import Link from '../composant/Link';
import Separator from '../composant/Separator';
import ERROR from '../composant/Errors';

import '../css/Article.css';

// function formatDate(data) {
//     const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
//     const date = new Date(data);
//     return date.toLocaleDateString('fr-FR', options);
// }

function RenderArt(art, id){
    if(art.data.length === 0){
        return (<ERROR messsage={'NO ARTICLE FOUND !'} color={'tomato'}></ERROR>);
    }
    return (
        <div className='articlePage'>
            <Link data={{
                display: true,
                name: '⬅️Retour',
                url: '/blog',
            }} className={"ReturnButton"}></Link>
            {
                art.data.map((val, index) => {
                    let current = val.attributes.article;

                    if (Number(id) === id) {
                        if(parseInt(id)){
                            current = val.id;
                        }
                    }

                    if(current === id){
                        return (
                            <div key={val.id}>
                                <div className='article'>
                                    <Header data={{
                                        title: `Orchidée | ${val.attributes.title}`,
                                        favicon: {
                                            data: {
                                                attributes: {
                                                    url: 'https://res.cloudinary.com/orchidee/image/upload/v1672523627/Orchidee_White_73d9d285a3.png'
                                                }
                                            }
                                        }
                                    }}></Header>
                                    <h2 className='title'>
                                        <Text data={val.attributes.title}></Text>
                                    </h2>
                                    <Separator data={{
                                        "separate": true,
                                        "mode": "line"
                                    }}></Separator>
                                    <div className='content'>
                                        {parseHTML(val.attributes.content)}
                                        {/* <ReactMarkdown skipHtml={false}>{val.attributes.content}</ReactMarkdown> */}
                                    </div>
                                    {/* <div className='Layout_colorBackground__Adyt4'></div>
                                    <div className='Layout_colorBackgroundBottom__9Yf_q'></div> */}
                                </div>
                                <div className='team'>
                                    {val.attributes.teams.data.map((team) => {
                                        return (
                                            <a href={`/team/${team.attributes.name}`}>
                                                <div className='member'>
                                                    <Images data={team.attributes.avatar}></Images>
                                                    <p>{team.attributes.name}</p>
                                                </div>
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    }
                    else{
                        return (<ERROR messsage={'NO ARTICLE FOUND !' + current + id} color={'tomato'}></ERROR>);
                    }
                })
            }
        </div>
    );
}

function Article({api, uid}) {
    const { id } = useParams();

    if(api != null){
        return RenderArt(api, uid);
    }
    else{
        return RenderArt(data, id);
    }
}

export default Article;
